import React from 'react'
import { withTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { useData } from "../../DataContext";
import { useForm } from "react-hook-form";
import { 
    Button,
    Box,
    Typography
} from '@material-ui/core';

import './MakePayment.scss'

import { 
    Navbar,
    Header,
    FormBox,
    Footer
} from '../../components/_index'

export default withTranslation()(function MakePayment({t}) {
    const { setValues } = useData();
    const history = useHistory();

    const { 
        handleSubmit, 
    } = useForm();

    const onSubmit = (data) => {
        console.log(data);
        setValues(data);
        history.push(`${process.env.REACT_APP_SUB_ROUTE}/submitSuccess`);
    };

    const printOut = () => {
        window.print();
    }

    return (
        <>
            <Box className="wrapper makePayment">
                <Header langLock="langLocked" />
                <Box className="mainWrapper">
                    <Navbar noStep />
                    <Box className="contentWrapper">
                        <form onSubmit={handleSubmit(onSubmit)} noValidate>
                            <FormBox header="makePayment.title">
                                <Box p={5}>
                                    <Box mb={6}>
                                        <Typography variant="body1">
                                            {t('makePayment.msg1')}
                                        </Typography>
                                    </Box>
                                    <Box mb={6}>
                                        <Typography variant="body1" className="bold">
                                            {t('makePayment.msg2')}
                                        </Typography>
                                    </Box>
                                    <Box mb={6}>
                                        <Typography variant="body1">
                                            {t('makePayment.msg3')}
                                        </Typography>
                                        <Typography variant="body1" className="bold">
                                            E123456
                                        </Typography>
                                    </Box>
                                    <Typography variant="body1">
                                        {t('makePayment.msg4')}
                                    </Typography>
                                    <Typography variant="body1">
                                        {t('makePayment.msg5')}
                                    </Typography>
                                </Box>
                            </FormBox>
                            <FormBox>
                                <Box
                                    display="flex" 
                                    justifyContent="flex-end"
                                >
                                    <Button 
                                        variant="contained" 
                                        color="secondary" 
                                        className="secBtn"
                                        onClick={printOut}
                                    >
                                        {t('common.button.save')}
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        color="secondary"
                                        className="secBtn"
                                        onClick={printOut}
                                    >
                                        {t('common.button.print')}
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        color="primary" 
                                        type="submit"
                                    >
                                        {t('common.button.payNow')}
                                    </Button>
                                </Box>
                            </FormBox>
                        </form>
                    </Box>
                </Box>
            </Box>
            <Footer />
        </>
    )
})
